export const AppUrl = 'https://api.oplii.com';
export const TELEMTRY_KEY = '25a58437-e507-424c-a88b-609bc10c6242';
export const MAX_FILE_UPLOAD = 50;
export const MAX_DOCUMENT_UPLOAD = 20;

export const GOOGLE_MAP_API_KEY = 'AIzaSyAmwbloJsGNDagTgYgzNPoxuLbfvouHYiE';
export const GOOGLE_MAP_ID = 'Google-Map-Id';
